import {
	LOCK_IN_DATA_REQUEST,
	LOCK_IN_DATA_SUCCESS,
	LOCK_IN_DATA_ERROR,
	LOCK_IN_REGISTER_ERROR
} from 'actions/lockInPageActions';
import { INIT, SUCCESS, ERROR, LOADING } from 'utils/asyncStatusHelper';

const defaultState = {
	asyncStatus: INIT
};

export default function lockInData(state = defaultState, action = null) {
	switch (action.type) {
		case LOCK_IN_DATA_REQUEST:
			return Object.assign({}, state, {
				asyncStatus: LOADING
			});
		case LOCK_IN_DATA_SUCCESS:
			return Object.assign({}, state, {
				asyncStatus: SUCCESS,
				actionType: 'pageDetails',
				...action.data
			});
		case LOCK_IN_DATA_ERROR:
			return Object.assign({}, state, {
				asyncStatus: ERROR,
				actionType: 'pageDetails',
				...action.error
			});
		case LOCK_IN_REGISTER_ERROR:
			return Object.assign({}, state, {
				asyncStatus: ERROR,
				actionType: 'Register',
				...action.error
			});
		default:
			return state;
	}
}
